import { Group, Text, Paper } from "@mantine/core";
import RequestStatusBadge from "./RequestStatusBadge";
import { IconArrowRight } from "@tabler/icons-react";
import { StatusUpdateModel } from "../types/comment.types";

interface CommentStatusUpdateProps {
  statusUpdate: StatusUpdateModel;
}

export default function CommentStatusUpdate(
  { statusUpdate }: CommentStatusUpdateProps
) {
  const { old_status, new_status } = statusUpdate;

  return (
    <Paper bg="gray.1" p="xs">
      <Text tt="uppercase" size="xs" c="gray.8" fw={700} mb="xs">
        Status update
      </Text>
      <Group gap={4}>
        <RequestStatusBadge status={old_status} size="xs" />
        <IconArrowRight size={14} />
        <RequestStatusBadge status={new_status} size="xs" />
      </Group>
    </Paper>
  );
}